import { UpgradeData } from '../data.type';
import { niceRounding } from '../helpers';
import { PRICE_STEP_COEFFICIENT, UPGRADE_PRICE_COEFFICIENT } from './baseData';
import { IMAGES } from './images';

export type ManagerUpgradeType = 'airplanes_per_second' | 'ticket_price_multiplier';

export const MANAGER_DATA = {};

export const MANAGER_UPGRADES: {
  [k in ManagerUpgradeType]: UpgradeData;
} = {
  // from 20 seconds per airplane to 2 seconds per airplane
  airplanes_per_second: {
    icon: IMAGES.ICONS.speed,
    maxValue: 40,
    description: 'Work speed efficiency',
    priceFn: (upgradeLevel, priceStep) =>
      niceRounding(500 * Math.pow(UPGRADE_PRICE_COEFFICIENT, upgradeLevel) * Math.pow(PRICE_STEP_COEFFICIENT, priceStep)),
    valueFn: (upgradeLevel) => 0.1 + upgradeLevel * 0.01625,
    readableValue: (upgradeLevel) => `${Math.round((upgradeLevel / MANAGER_UPGRADES.airplanes_per_second.maxValue) * 100)}%`,
  },
  ticket_price_multiplier: {
    icon: IMAGES.ICONS.ticket,
    maxValue: 50,
    description: 'Price multiplier, applied to the ticket price',
    priceFn: (upgradeLevel, priceStep) =>
      niceRounding(500 * Math.pow(UPGRADE_PRICE_COEFFICIENT, upgradeLevel) * Math.pow(PRICE_STEP_COEFFICIENT, priceStep)),
    valueFn: (upgradeLevel) => 1 + upgradeLevel * 0.02,
    readableValue: (upgradeLevel) => `x${MANAGER_UPGRADES.ticket_price_multiplier.valueFn(upgradeLevel).toFixed(2)}`,
  },
};
